export  class ProductStruct {
    category=""
    productList=[]
}

